import { render, staticRenderFns } from "./BeAdvised.vue?vue&type=template&id=d1caae9e&scoped=true&"
import script from "./BeAdvised.vue?vue&type=script&lang=js&"
export * from "./BeAdvised.vue?vue&type=script&lang=js&"
import style0 from "./BeAdvised.vue?vue&type=style&index=0&id=d1caae9e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1caae9e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/components/Button.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default})
